import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceDeliveryLocationsShellComponent } from './service-delivery-locations-shell.component';
import { AppSharedModule } from '../../appSharedModule/app-shared.module';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  ServiceDeliveryLocationsPanelComponent
} from './service-delivery-locations-panel/service-delivery-locations-panel.component';
import {
  ServiceDeliveryLocationDetailsComponent
} from './service-delivery-location-details/service-delivery-location-details.component';
import {
  ServiceDeliveryLocationMapComponent
} from './service-delivery-location-map/service-delivery-location-map.component';
import { AddpDialogComponent } from './addp/addp-dialog/addp-dialog.component';
import { AddpCartFormComponent } from './addp/addp-cart-form/addp-cart-form.component';

@NgModule({
  declarations: [
    ServiceDeliveryLocationsShellComponent,
    ServiceDeliveryLocationsPanelComponent,
    ServiceDeliveryLocationDetailsComponent,
    ServiceDeliveryLocationMapComponent,
    AddpDialogComponent,
    AddpCartFormComponent
  ],
  imports: [
    CommonModule,
    AppSharedModule,
    DropdownModule,
    FormsModule,
    RouterModule
  ],
  exports: [
    AddpCartFormComponent
  ]
})
export class ServiceDeliveryLocationsModule { }
